import { FetchClient } from '@yellowtail-frontend/cord-connector';
import { from, Observable } from 'rxjs';

export class OcktoReceiverApiService extends FetchClient {
  constructor(baseUrl: string) {
    super();
    this.baseUrl = baseUrl;
  }

  public post$<T>(resource: string, data: object): Observable<T> {
    return from(this.post(resource, data));
  }
}
